import { render, staticRenderFns } from "./PurchaseOrdersDialog.vue?vue&type=template&id=9e06c3fc&scoped=true"
import script from "./PurchaseOrdersDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseOrdersDialog.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrdersDialog.vue?vue&type=style&index=0&id=9e06c3fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e06c3fc",
  null
  
)

export default component.exports